import styled from 'styled-components'

const ImageContainer = styled.div`
  position: relative;
  max-width: ${props => (props.isGrid ? '100%' : '290px')};
  height: ${props => (props.isGrid ? '' : '100%')};
  width: 100%;

  overflow: hidden;

  cursor: ${props => props.onClick ? 'pointer' : ''};
`

export default ImageContainer
